import { Component, OnInit, Input } from '@angular/core';
import {
  AdressesDestinatairesService,
  GlobalDataService,
  PersonalisationService,
} from '@core/services';

@Component({
  selector: 'app-campagne-save',
  templateUrl: './campagne-save.component.html',
  styleUrls: ['./campagne-save.component.scss'],
})
export class CampagneSaveComponent implements OnInit {
  waitingForServer = false;

  @Input() campaignName: string;

  constructor(
    readonly _GlobalDataService: GlobalDataService,
    private _PersonalisationService: PersonalisationService,
    private _AdressesDestinatairesService: AdressesDestinatairesService
  ) {}

  ngOnInit(): void {}

  public save(): void {
    const nomCampagne = this._GlobalDataService.Campagne.NomCampagne;

    if (
      nomCampagne === undefined ||
      nomCampagne === null ||
      nomCampagne === ''
    ) {
      this._GlobalDataService.alert(
        'Enregistrement non autorisé.<br>Le nom de la campagne est obligatoire et doit-être unique. Merci de renseigner un nom de campagne.'
      );
      return;
    }

    this.waitingForServer = true;

    const saveFusion = this._GlobalDataService.stepIndex === 3;

    if (saveFusion) {
      this._PersonalisationService.setChampFusionType();

      this._GlobalDataService.CampagneExt.ChampsFusion =
        this._PersonalisationService.selectedChampsFusion.concat(
          this._AdressesDestinatairesService.selectedChampsFusion
        );
    }

    this._GlobalDataService
      .saveAll(this._GlobalDataService.Campagne, saveFusion)
      .subscribe({
        complete: () => {
          const idCampagne = this._GlobalDataService.Campagne?.IdCampagne;
          const isNewCampaignRoute = this._GlobalDataService.isNewCampaignWizardRoute();

          /**
           * IMPORTANT :
           * Avant, le code faisait :
           * saveNavViewState(['nouvelle-campagne'])
           *
           * Ce qui écrasait l'état de navigation après Enregistrer.
           * Maintenant, on sauvegarde la vraie route de création :
           * ['campagne-details', IdCampagne]
           */
          if (idCampagne && !isNewCampaignRoute) {
            this._GlobalDataService.saveNavViewState(
              ['campagne-details', idCampagne],
              'STANDALONE'
            );
          } else if (isNewCampaignRoute) {
            this._GlobalDataService.saveNavViewState(
              ['nouvelle-campagne'],
              'STANDALONE'
            );
          }

          this._GlobalDataService.saveCampaignStep(
            isNewCampaignRoute ? null : idCampagne || null,
            this._GlobalDataService.stepIndex
          );

          this._GlobalDataService.saveCampaignDraft(
            this._GlobalDataService.Campagne,
            this._GlobalDataService.CampagneExt,
            isNewCampaignRoute ? null : idCampagne || null,
          );

          this._GlobalDataService.alert(
            'Votre campagne a bien été enregistrée.'
          );

          this.waitingForServer = false;
        },

        error: (e) => {
          const message = e?.error?.message || e?.message || 'Impossible d\'enregistrer la campagne.';
          this._GlobalDataService.openSnackBarInfo(message);
          this.waitingForServer = false;
        },
      });
  }
}
